import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { c } from '@debbie/cortex/dist/index.js';
import { searchAll } from '../search/index.js';
import SearchIcon from './Icons/Search.js';
import SearchInput from './SearchInput.js';
import Shortcut from './Shortcut.js';
const Search = (props) => {
    const inp = useRef(null);
    const onSelectHandler = props.onSelect
        ? props.onSelect
        : (result) => {
            c.redirect.redirect(`/cases/${result.caseSeqId}`);
        };
    const lang = useSelector((s) => s.lang);
    if (props.removeWrapper) {
        return (React.createElement(SearchInput, { inputRef: inp, searchDelay: 300, inputStyle: props.removeWrapper
                ? {}
                : {
                    borderRadius: '17.5px',
                }, onSelect: onSelectHandler, placeholder: props.removeWrapper ? (lang.navigation.search) : (React.createElement(PositionedSpan, null,
                React.createElement(IconContainer, null,
                    React.createElement(SearchIcon, { style: { width: '1.25em', height: '1.25em' } })),
                React.createElement(SpanWithMargin, null, lang.navigation.search))), searchAll: (q) => searchAll(lang, q) }));
    }
    return (React.createElement(Wrapper, { ...props },
        React.createElement(Shortcut, { keys: ['command', 'e'], onPress: (e) => {
                e.preventDefault();
                inp?.current?.focus();
            }, style: {
                left: '10px',
                top: '7px',
            } }),
        React.createElement(SearchInput, { inputRef: inp, searchDelay: 300, inputStyle: props.removeWrapper
                ? {}
                : {
                    borderRadius: '17.5px',
                }, onSelect: onSelectHandler, placeholder: props.removeWrapper ? (lang.navigation.search) : (React.createElement(PositionedSpan, null,
                React.createElement(IconContainer, null,
                    React.createElement(SearchIcon, { style: { width: '1.25em', height: '1.25em' } })),
                React.createElement(SpanWithMargin, null, lang.navigation.search))), searchAll: (q) => searchAll(lang, q) })));
};
export default Search;
const Wrapper = styled.div `
  z-index: 999;
  em {
    font-style: normal;
    text-decoration: underline;
  }

  svg {
    position: absolute;
    right: 0;
    top: 10px;
  }

  ${(props) => props.removeWrapper
    ? ``
    : `
          display: inline-block;
          max-width: 550px;
          width: calc(100% - 320px);
          margin-top: -3px;
          z-index: 99999;

          input {
            box-shadow: none;
            border: none;
            padding: 17px 15px 3px 15px;
            font-size: 0.8em;
          }

          .inp-placeholder {
            top: 10px;
          }
`};
`;
const PositionedSpan = styled.span `
  position: relative;
`;
const IconContainer = styled.span `
  height: 16px;
  width: 16px;
  position: absolute;
  top: -10px;
`;
const SpanWithMargin = styled.span `
  margin-left: 2em;
`;
//# sourceMappingURL=Search.js.map